import { Results } from '../../voting';
import { Name as EntityName } from '../../entity';

export const TYPE = `${EntityName.ACTION_PREFIX}VOTING:results_enter`;

export interface Payload {
    results: Results.Results;
}
